import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
	Tab, Nav, NavItem, Row, Col,
	FormGroup, InputGroup, Button,
	DropdownButton, MenuItem, Panel
} from 'react-bootstrap';
import {NewTask, TasksList} from '../';

import * as Actions from 'actions';

class TasksContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show_completed_tasks : false
		}
	}

	componentWillMount() {
		if(this.props.client) {
			this.props.initUsersChildren()
		}
	}

	render() {
		return (
			<div className='tasks-container'>
				{(() => {
					if(!this.props.tasks || this.props.tasks.length <= 0) {
						return (
							<div>
								<NewTask client={this.props.client}/>
								<hr className='dotted short' />
								<h4>No current tasks</h4>
							</div>
							)
					}
					else {
						return (
							<Tab.Container
								id='tasks-tabs-container'
								defaultActiveKey='first'>
								<Row className='clearfix'>
									<div className='col-md-12 col-xs-12 task-column'>
										<div className='col-md-12 col-xs-12'>
											<h3 className='mb-lg'>
												Manage Tasks
											</h3>
										</div>
										<div className='col-xs-12'>
											<NewTask client={this.props.client}/>
										</div>
										<hr className='dotted short' />
				            <div className='tasks-list'>
	            				<Panel>
			            			<h4><strong>INCOMPLETE</strong></h4>
				            		<TasksList
						            	tasks={this.props.tasks ? this.props.tasks.filter(t => !t.completed) : []}
						            />
					            </Panel>
				            </div>
				            {(() => {
				            	if(this.props.tasks.find(t => t.completed)) {
				            		return (
				            			<div>
				            				<div 
								            	className='show-completed-tasks-button'
								            	onClick={() => {this.setState({show_completed_tasks : !this.state.show_completed_tasks})}}
								            	>
								            	{(() => {
								            		if(this.state.show_completed_tasks)
									            		return <h4>Hide Completed Tasks</h4>
									            	else 
									            		return <h4>Show Completed Tasks</h4>
								            	})()}
								            </div>
					            			<div className='tasks-list'>
					            				<Panel collapsible expanded={this.state.show_completed_tasks}>
							            			<h4><strong>COMPLETED</strong></h4>
								            		<TasksList
										            	tasks={this.props.tasks ? this.props.tasks.filter(t => t.completed) : []}
										            />
									            </Panel>
								            </div>
				            			</div>
				            			)
				            	}
				            })()}
									</div>
								</Row>
							</Tab.Container>
							)
					}
				})()}
			</div>
		)
	}
}

export default connect(null, Actions)(TasksContainer)


// WEBPACK FOOTER //
// ./src/browser/components/tasks/tasksContainer.js